import { createAction } from 'redux-act';

export const uploadFile = createAction('Upload file');

export const setFileModalOpened = createAction('Set file modal opened');
export const setLoading = createAction('Set upload file loading');
export const setUploadSuccess = createAction('Set upload successfull');

export const fileUploadReset = createAction('File upload reset');
